$(function(){
  if ($('.calenderContainer').length > 0) {
    var bouquets = parseInt($('.Popover__ValueList button.is-selected').attr('data-value'));
    initFlatpickr(bouquets);
  }
  scrollFade();
  initFlickity();
});

initFlickity = () =>{
  setTimeout(function(){
    $('.slider-container').flickity({
      watchCSS: true,
      prevNextButtons: true,
      wrapAround: true,
      cellAlign: 'left',
      pageDots: false,
      adaptiveHeight: true
    });
  },3000);

  $('.jsc-object-slider').flickity({
    prevNextButtons: true,
    wrapAround: true,
    cellAlign: 'left',
    pageDots: false,
    adaptiveHeight: true
  });
}

showCalender = (evt) =>{
  var $variantVal = parseInt(evt.currentVariant['title']);
  if ($('.calenderContainer').length > 0) {
  //   $('.calenderContainer').empty();
  //
  //   for (var i = 1; i <= $variantVal; i++) {
  //     var properties_html = '<p class="line-item-property__field"> <label for="date'+i+'">Date '+i+':</label> <input id="date'+i+'" class="dateInput" type="text" name="properties[Date'+i+']"></p>';
  //
  //     $('.calenderContainer').append(properties_html);
  //   }
    initFlatpickr($variantVal);
  }
}

initFlatpickr = (limit) =>{
  $("#date").flatpickr({
    dateFormat: "d-M-Y",
    minDate: new Date().fp_incr(2),
    mode: "multiple",
    onChange: function(selectedDates, dateStr, instance){
      var array = selectedDates;
      if (array.length >= limit) {
        instance.set('enable', selectedDates);
      } else {
        instance.set('enable', []);
      }
    }
  });
}

scrollFade = () =>{
  $(window).scroll(function(){
    var $header = $('#section-header');
    var $offset = $header.offset();
    console.log('yeloo',$offset.top);

    if ($offset.top >= 1000 || $offset.top <= 50) {
      $header.css('opacity', 1);
    }
    else {
      $header.css('opacity', 0.5);
    }
  });
}

$('#message').keyup(function () {
  max = this.getAttribute("maxlength");
  var len = $(this).val().length;

  if (len >= max) {
    $('#charNum').text(' You have reached the limit');
  } else {
    var char = max - len;
    $('#charNum').text(char + ' characters left');
  }
});
